export const EDITOR_MODAL_UPLOAD_TAB_IMAGES = 'Image';
export const EDITOR_MODAL_UPLOAD_TAB_VIDEOS = 'Video';
